import styled from '@emotion/styled';
import { useFullRelease } from '@/common/hooks_useFullRelease';
import { WithGraphCoreSplit } from '@/components/GraphVisualisation/GraphViz';
import Data from '@/components/GraphVisualisation/components/Data/Data';
import RuleGraphProvider from '@/components/GraphVisualisation/providers/RuleGraphProvider';
import { useSessionDecisionGraph } from '../sessionGraph';
import ReleaseContextProvider from "@/pages/models/release/ReleaseContextProvider";


const StyledWithGraphCoreSplit = styled(WithGraphCoreSplit)`
  height: 100% !important;
`;


export const DataPanel = ({
  session,
  onGoToInputAndSelectInteraction,
  release: releaseProp,
}: {
  session: any;
  onGoToInputAndSelectInteraction?: (interactionId: string) => void;
  release?: any;
}) => {
  const fullRelease = useFullRelease();
  const release = releaseProp ?? fullRelease;
  // the session's graph as a decision graph (converted once per graph)
  const graph = useSessionDecisionGraph();
  const goalId = graph?.ref(session.goal);
  const goal = goalId !== undefined ? graph!.deref(goalId) : session.goal;

  return (
    <RuleGraphProvider
      graph={graph}
      goal={goal}
      debug={true}
    >
      {/* TODO remove me - legacy support */}
      <ReleaseContextProvider release={release as any}>
        <StyledWithGraphCoreSplit>
          <Data
            session={session}
            onGoToInputAndSelectInteraction={onGoToInputAndSelectInteraction}
          />
        </StyledWithGraphCoreSplit>
      </ReleaseContextProvider>
    </RuleGraphProvider>
  );
};
